module.exports = __webpack_public_path__ + "img/study-withus.3fd1a53b.jpg";